<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false :class="fromLocation==='msg'?'msg-create-application':''">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon v-if="fromLocation==='app'" style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="retreatModalVisible=true" v-if="item.action==='withdraw'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEnter'" />撤回
          </span>
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
          <span class="extra-trigger" @click="modify" v-if="item.action==='modify_form'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEdit'" />修改
          </span>
          <span class="extra-trigger" @click="copy" v-if="item.action==='copy'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcCopy'" />复制
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="'commonForm'" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @current-changed-field="getCurrentChanged" @update="update" @event-relay="eventRelay"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @current-changed-field="getCurrentChanged" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <a-modal :visible="retreatModalVisible" title="撤回" @ok="retreat" :confirm-loading="retreatLoading" @cancel="retreatModalVisible=false">
        <h4>你确定撤回报销申请吗？</h4>
      </a-modal>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcAll from "../../assets/svg/ic-all-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  reimburseBaseLayout,
  getReimburseDetailInfo,
  reimburseCreateInfo,
  submitReimburse,
  getReimburseDetailApprovalFlow,
  printUrl,
  approvalApplication
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload
  },
  data() {
    return {
      introductionVisible: false,
      retreatModalVisible: false,
      canEdit: false,
      breadcrumb: [
        {
          label: "发起申请",
          path: {
            name: "launchApplication"
          }
        },
        {
          label: "发起报销申请",
          path: ""
        }
      ],
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      loadedInfo: false,
      pageLayout: {},
      approvalFlowInfo: [],
      fromLocation: undefined,
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      retreatLoading: false,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    Promise.all([this.getReimburseDetailInfo(this.id)]).then(() => {
      this.fetchPageLayout();
    });
  },

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          type: this.requestParams.basicInfo.type,
          company_id: this.requestParams.basicInfo.company_id,
          total_pay: this.requestParams.total_pay
        };
      }
    }
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo
      );
    },
    // 获取整个页面表单布局
    fetchPageLayout() {
      this.loadedLayout = false;
      reimburseBaseLayout({
        id: this.$route.query.id,
        show_type: "detail",
        menu_type: 1,
        ding_msg_switch: this.fromLocation === "msg" ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getReimburseDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取详情信息
    getReimburseDetailInfo(id) {
      return getReimburseDetailInfo(id, { menu_type: 1 }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "myApplicationList",
        query: {
          apply_type: 2
        }
      });
    },
    update() {},
    getNeighorByField(val) {
      let vm = null;
      Object.keys(this.$refs).forEach(key => {
        const field = key.substr(key.indexOf("_") + 1);
        if (field === val) {
          vm = this.$refs[key];
        }
      });
      return vm[0];
    },
    eventRelay(e) {
      const self_event = e[0];
      let behind_event = _.cloneDeep(e);
      behind_event.shift();
      if (self_event.selfDo === "emit") {
        this.$emit("event-relay", behind_event);
      } else if (self_event.selfDo === "passNeighor") {
        let neighorVm = this.getNeighorByField(self_event.params.value);
        neighorVm.eventRelay(behind_event);
      }
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    getCurrentChanged(e) {},
    print() {
      const accessToken = localStorage.getItem("accessToken");
      location.href = `${window.location.origin}/api/oa/reimburse/pdf/${
        this.$route.query.id
      }?accessToken=${accessToken}`;
    },
    copy() {
      this.$router.replace({
        name: "createReimbursement",
        query: {
          id: this.$route.query.id
        }
      });
    },
    modify() {
      this.$router.replace({
        name: "myReimbursementDetailEdit",
        query: {
          id: this.$route.query.id,
          type: "create"
        }
      });
    },
    retreat() {
      let params = {
        applyId: this.$route.query.id,
        status: 4,
        applyType: 2
      };
      this.retreatLoading = true;
      approvalApplication(params).then(res => {
        if (res.status === "success") {
          this.retreatModalVisible = false;
          this.$Message.success("撤回成功");
          this.back();
        } else {
          this.$Message.error(res.message);
        }
        this.retreatLoading = false;
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.type &&
          val.company_id &&
          val.total_pay &&
          val.total_pay !== "0.00"
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
